export const generateUserRoute = (userSlug: string) =>
  `/settings/users/edit?id=${userSlug}`;
export interface Route {
  href: string;
  label: string;
}

export const asRoute = (route: Route): Route => route;
